export default "__VITE_ASSET__kfj_8_xG__"